export enum UserStatuses {
  ACTIVE = 'ACTIVE',
  DEPROVISIONED = 'DEPROVISIONED',
  LOCKED_OUT = 'LOCKED_OUT',
  PASSWORD_EXPIRED = 'PASSWORD_EXPIRED',
  PROVISIONED = 'PROVISIONED',
  RECOVERY = 'RECOVERY',
  STAGED = 'STAGED',
  SUSPENDED = 'SUSPENDED',
}
